<template>
    <div>
        <v-container grid-list-lg fluid>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-flex lg4 md12 sm12 pr-6 pl-lg-6>
                            <v-layout row wrap justify-end>
                                <v-menu v-model="menuStart" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="computedStartDateFormatted" label="Từ ngày"
                                            hint="DD-MM-YYYY" persistent-hint prepend-icon="fa-calendar-alt" readonly
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dateRange.startDate" no-title
                                        @input="menuStart = false"></v-date-picker>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                        <v-flex lg4 md12 sm12 pr-6>
                            <v-layout row wrap justify-end>
                                <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition"
                                    offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="computedEndDateFormatted" label="Đến ngày"
                                            hint="DD-MM-YYYY" persistent-hint prepend-icon="fa-calendar-alt" readonly
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dateRange.endDate" no-title
                                        @input="menuEnd = false"></v-date-picker>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                        <v-flex lg4 md12 sm12 pr-6>
                            <v-btn @click="filter_data" color="#1977ff" outlined>Xem</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex lg12>
                    <v-card class="mb-8">
                        <hpo-filter  placeholder="Tìm kiếm theo mã đơn hàng" :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                        <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"  :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.OrderType == 1 ? "MD" : "KG" }}{{ item.ID }}</td>
                                    <td>{{ item.Username }}</td>
                                    <td>{{ item.OrderType | display_value(order_types) }}</td>
                                    <td>{{ item.SaleID | display_value(staffs, 'ID', 'Username') }}</td>
                                    <td>{{ item.CustomerServiceID | display_value(cs_staffs, 'ID', 'Username') }}</td>
                                    <td>{{ item.BuyerID | display_value(p_staffs, 'ID', 'Username') }}</td>
                                    <td class="text-end">{{ item.TotalFeeWeight | currency }}</td>
                                    <td class="text-end">{{ item.TotalCostWeight | currency }}</td>
                                    <td class="text-end">{{ item.TotalProfitWeight | currency }}</td>
                                    <td class="text-end">{{ item.FeeBuyAmount | currency }}</td>
                                    <td class="text-end">{{ item.TotalProfitProduct | currency }}</td>
                                    <td class="text-end">{{ item.TotalSaleCommission | currency }}</td>
                                    <td class="text-end">{{ item.TotalCSCommission | currency }}</td>
                                    <td class="text-end">{{ item.TotalBuyerCommission | currency }}</td>
                                </tr>
                            </template>
                            <template v-slot:body.append v-if="summary">
                                <tr>
                                    <td class="font-weight-bold" colspan="6">TỔNG</td>
                                    <td class="font-weight-bold text-end">{{ summary.TotalFeeWeight | currency }}</td>
                                    <td class="font-weight-bold text-end">{{ summary.TotalCostWeight | currency }}</td>
                                    <td class="font-weight-bold text-end">{{ summary.TotalProfitWeight | currency }}</td>
                                    <td class="font-weight-bold text-end">{{ summary.FeeBuyAmount | currency }}</td>
                                    <td class="font-weight-bold text-end">{{ summary.TotalProfitProduct | currency }}</td>
                                    <td class="font-weight-bold text-end">{{ summary.TotalSaleCommission | currency }}</td>
                                    <td class="font-weight-bold text-end">{{ summary.TotalCSCommission | currency }}</td>
                                    <td class="font-weight-bold text-end">{{ summary.TotalBuyerCommission | currency }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
// import { Chart } from 'highcharts-vue';
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "bao-cao-loi-nhuan",
            order_types: configs.ORDER_TYPE_LIST,
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: []
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.profitReport.data,
            total_rows: state => state.report.profitReport.total,
            summary: state => state.report.profitReport.summary,
            loading: state => state.report.loading,
            staffs: (state) => state.commons.all_users,
            p_staffs: (state) =>
                _.filter(state.commons.all_users, function(o) {
                return (
                    (o.RoleType & configs.ROLE_TYPE.Purchase) ==
                    configs.ROLE_TYPE.Purchase
                );
                }),
            cs_staffs: (state) =>
                _.filter(state.commons.all_users, function(o) {
                return (
                    (o.RoleType & configs.ROLE_TYPE.CustomerService) ==
                    configs.ROLE_TYPE.CustomerService
                );
                }),
        }),
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        headers() {
            return [
                {
                    text: "Đơn hàng",
                    value: "ID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Loại đơn",
                    value: "OrderType",
                    filterable: true,
                    values: configs.ORDER_TYPE_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Sale",
                    value: "SaleID",
                    filterable: true,
                    values: _.map(this.staffs, (item) => {
                        return {
                            value: item.ID,
                            name: item.Username
                        }
                    }) || [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "CSKH",
                    value: "CustomerServiceID",
                    filterable: true,
                    values: _.map(this.cs_staffs, (item) => {
                        return {
                            value: item.ID,
                            name: item.Username
                        }
                    }) || [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Đặt hàng",
                    value: "BuyerID",
                    filterable: true,
                    values: _.map(this.p_staffs, (item) => {
                        return {
                            value: item.ID,
                            name: item.Username
                        }
                    }) || [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Cước vận chuyển",
                    value: "TotalFeeWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí gốc vận chuyển",
                    value: "TotalCostWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Lợi nhuận vận chuyển",
                    value: "TotalProfitWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí mua hàng",
                    value: "FeeBuyAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chênh lệch tiền hàng",
                    value: "TotalProfitProduct",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Hoa hồng sale",
                    value: "TotalSaleCommission",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Hoa hồng CSKH",
                    value: "TotalCSCommission",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Hoa hồng đặt hàng",
                    value: "TotalBuyerCommission",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                }
            ];
        } 
    },
    watch: {
        pagination: {
            handler: function(val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
            this.$store.dispatch("report/getProfitReport", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
    },
    mounted() {
        this.filter_data();
        this.$store.dispatch("commons/getAllUsers");
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}

.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>